module.exports = __webpack_public_path__ + "img/2.e00d3758.png";